import React, { Suspense } from 'react';
import { LoadingPanel } from '.';

const SuspenseLazy: React.FC<any> = ({ ...props }) => {
    return <Suspense fallback={<LoadingPanel top={30} />}>{props.children}</Suspense>;
};

export default SuspenseLazy;
